import React from 'react';
import { Button } from '../ui/Button';
import { Terminal, Code, Cpu, Shield, Zap, BookOpen } from 'lucide-react';
export function DeveloperCallout() {
  const features = [{
    icon: Terminal,
    label: 'REST APIs'
  }, {
    icon: Code,
    label: 'SDKs (Node, Python, Go)'
  }, {
    icon: Zap,
    label: 'Webhooks'
  }, {
    icon: Cpu,
    label: 'Sandbox & Prod Parity'
  }, {
    icon: Shield,
    label: 'Clear Error Handling'
  }, {
    icon: BookOpen,
    label: 'OpenAPI Specs'
  }];
  return <section className="py-24 bg-slate-900 text-white" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-162">
          <div className="text-center lg:text-left" data-id="element-163">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6" data-id="element-164">
              Built for developers.
              <br data-id="element-165" />
              Trusted by institutions.
            </h2>
            <p className="text-slate-400 text-base sm:text-lg mb-8 max-w-md mx-auto lg:mx-0" data-id="element-166">
              Integrate banking, crypto, and payment rails with a single,
              elegant API designed for scale and reliability.
            </p>
            <a href="#/docs" className="inline-block" data-id="element-167">
              <Button variant="secondary" size="lg" data-id="element-168">
                View Documentation
              </Button>
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6" data-id="element-169">
            {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center p-4 rounded-xl bg-slate-800/50 border border-slate-700 hover:bg-slate-800 transition-colors" data-id="element-170">
                <feature.icon className="w-8 h-8 text-blue-400 mb-3" data-id="element-171" />
                <span className="text-sm font-medium text-slate-300" data-id="element-172">
                  {feature.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}